import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";

import api from "../api";
import { QUERY_KEYS, ROUTE_PREFIX } from "../constants";
import getRoutePrefix from "../utils/getRoutePrefix";

const fetcher = api();
const ALLOWED_ROUTE_PREFIXES = Object.values(ROUTE_PREFIX).filter(
  (path) =>
    ![
      ROUTE_PREFIX.FIVE_HUNDRED,
      ROUTE_PREFIX.FOUR_O_FOUR,
      ROUTE_PREFIX.NEWSLETTER_SIGNUP,
      ROUTE_PREFIX.FORGOT_PASSWORD,
      ROUTE_PREFIX.EXTERNAL_LINK_DISCLAIMER,
    ].includes(path),
);

export default function useOnSiteMessagesQuery(
  { contentType, contentId },
  options = {},
) {
  const pathname = usePathname();

  const routePrefix = getRoutePrefix(pathname);
  const {
    data: onSiteMessages,
    isLoading: isOnSiteMessagesLoading,
    isError: onSiteMessagesError,
  } = useQuery({
    queryKey: [QUERY_KEYS.ON_SITE_MESSAGES, contentType, contentId],
    queryFn: () => fetcher.getOnSiteMessagesV2(contentType, contentId),
    enabled: !!(
      ALLOWED_ROUTE_PREFIXES.includes(routePrefix) &&
      contentType &&
      contentId
    ),
    ...options,
  });

  return {
    onSiteMessages,
    isOnSiteMessagesLoading,
    onSiteMessagesError,
  };
}
